import PropTypes from 'prop-types';

const fontFamily = "'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'";

export const CARCODE_THEME_CONFIG = {
  height: '40',
  width: '157',
  buttonColor: '#ffffff',
  buttonBorderRadius: '3',
  backgroundButtonColor: '#0069bf',
  formButtonBackgroundColor: '#0069bf',
  formHeaderBackgroundColor: '#0069bf',
  chatInputAreaBackgroundColor: '#0069bf',
  fontSize: '14',
  fontFamily,
  offsetX: 0,
  offsetY: 0,
};

export const CARCODE_CONFIG = {
  leadTags: '',
  callOutDelay: 30,
  disableGoogleAnalytics: true,
  disableEdwAnalytics: true,
  disableGtmAnalytics: false,
  skipButton: false,
  enableCallOut: true,
  alwaysOpenForm: true,
  isAutoOpenChat: true,
  buttonText: 'CONTACT US',
  phoneNumberPolicy: 'edmunds-first',
  floatingButtonPosition: 'bottom center',
  themeConfiguration: CARCODE_THEME_CONFIG,
  zIndex: 1050, // 1020 ($zindex-sticky-outer-wrapper) < 1035 ($zindex-global-nav) < zIndex < 1055 ($zindex-modal-drawer)
};

export const CARCODE_CONFIG_ENTITY = PropTypes.shape({
  leadTags: PropTypes.string,
  callOutDelay: PropTypes.number,
  disableGoogleAnalytics: PropTypes.bool,
  disableEdwAnalytics: PropTypes.bool,
  disableGtmAnalytics: PropTypes.bool,
  skipButton: PropTypes.bool,
  enableCallOut: PropTypes.bool,
  useGlobalCalloutStatus: PropTypes.bool,
  alwaysOpenForm: PropTypes.bool,
  isAutoOpenChat: PropTypes.bool,
  buttonText: PropTypes.string,
  phoneNumberPolicy: PropTypes.string,
  floatingButtonPosition: PropTypes.string,
  themeConfiguration: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonBorderRadius: PropTypes.string,
    backgroundButtonColor: PropTypes.string,
    formButtonBackgroundColor: PropTypes.string,
    fontSize: PropTypes.string,
    fontFamily: PropTypes.string,
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
  }),
  zIndex: PropTypes.number,
  chatClickHandler: PropTypes.func,
});

export const CUSTOM_CARCODE_CONFIG = {
  enableCallOut: false,
};

export const ASK_A_QUESTION = 'Ask a Question';

export const CARCODE_SDK_INITIALIZED_MESSAGE = 'carcode-widget-sdk-initialized';
